<template>
  <div ref="content">

    <div class="nonPrint" style="margin-top: 20px;">
      <v-toolbar dark class="toolbarcreatedadmin nonPrint" style="margin-top: 20px;">
      <v-btn icon @click="routeinfo()">
        <v-icon>fas fa-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>รายละเอียดข้อมูล</v-toolbar-title>
    </v-toolbar>


<div style="height: calc(100vh - 140px);">

      <div class="nonPrint positionPrint" >
        <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="ma-2" outlined fab small color="#a80f00" @click="changeRole()" v-on="on">
        <img :src="BASE_URL + 'static/iconButton/role_change_3.svg'" alt="" width="25px">
      </v-btn>
        </template>
        <span class="nonPrint">เปลี่ยนประเภทผู้ใช้งาน</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="ma-2" outlined fab small color="#a80f00" @click="print()" v-on="on">
        <img :src="BASE_URL + 'static/iconButton/printing.png'" alt="" width="25px">
      </v-btn>
        </template>
        <span class="nonPrint">Print</span>
      </v-tooltip>

      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="ma-2" outlined fab small color="#a80f00" @click="print()" v-on="on">
        <img :src="BASE_URL + 'static/iconButton/role_change_3.svg'" alt="" width="25px">
      </v-btn>
        </template>
        <span class="nonPrint">เปลี่ยนประเภทผู้ใช้งาน</span>
      </v-tooltip> -->
  </div>
<div>
      <img :src="API_BACKEND + '/v1/thumbnail/' + data_user.profile_picture" height="200" v-if="data_user.profile_picture">
    </div>

    <table class="tableInfor" style="margin-top: 20px;">
      <tr>
        <td class="div_infor_header">User ID:</td>
        <td class="div_infor" colspan="3">{{userid}}</td>
      </tr>
      <tr>
        <td class="div_infor_header">ชื่อ-นามสกุล:</td>
        <td class="div_infor">{{ name(data_user.first_name,data_user.last_name) }}
          <v-chip class="ma-2" x-small v-if="data_user.role !=='user'"> {{data_user.role}} </v-chip></td>
        <td class="div_infor_header">ชื่อผู้ใช้งาน:</td>
        <td class="div_infor">{{ (data_user.username)? data_user.username:'-' }}</td>
      </tr>
      <tr>
        <td class="div_infor_header">เบอร์โทรศัพท์:</td>
        <td class="div_infor">{{ (data_user.phone)? data_user.phone:'-' }}</td>
        <td class="div_infor_header">อีเมล:</td>
        <td class="div_infor">{{ (data_user.email)? data_user.email:'-' }}</td>
      </tr>

      <tr>
        <td class="div_infor_header">ลงทะเบียน:</td>
        <td class="div_infor" colspan="3">{{ momentdatethai(data_user.create_at)}} {{ momenttimethai(data_user.create_at)}}น.</td>
      </tr>
    </table>

    <table class="tableInfor" style="margin-top: 15px;">
      <tr>
        <td class="div_infor_headerDetail">ประเภทผู้ใช้งาน:</td>
        <td class="div_infor">{{ data_user.role}}</td>
        <td class="div_infor_headerDetail">บริษัท:</td>
        <td class="div_infor">{{ (data_user.company_name)? (data_user.company_name): '-'}}</td>
      </tr>
      <tr>
        <td class="div_infor_headerDetail">อาสาสมัคร:</td>
        <td class="div_infor" colspan="3">{{ volunteer(data_user.is_runner, data_user.is_cpr)}}</td>
      </tr>
    </table>

</div>
    <!-- -->
   </div>


   <div id="PDF" style="margin-top: 30px;">
      <div>
      <div class="pageBreak" style="justify-content: center; display: grid;">

        <p style="margin-top: 30px;font-weight: bold;font-size: 30px">ข้อมูลผู้ใช้งาน</p>
        <img :src="API_BACKEND + '/v1/' + data_user.profile_picture" height="200" style="justify-self: center;" v-if="data_user.profile_picture">


<table class="customers" style="margin-top: 30px;">
  <tr>
    <th>User ID:</th>
    <td>{{userid}}</td>
  </tr>
  </table>
  <p style="margin-top: 30px;text-align: left;font-weight: bold;margin-bottom: 0px;">ข้อมูลส่วนตัว</p>
  <table class="customers">
  <tr>
    <th>ชื่อ-นามสกุล:</th>
    <td>{{ name(data_user.first_name,data_user.last_name) }}</td>
  </tr>
  <tr>
    <th>ชื่อผู้ใช้งาน:</th>
    <td>{{ (data_user.username)? data_user.username:'-' }}</td>
  </tr>
  <tr>
    <th>เบอร์โทรศัพท์:</th>
    <td>{{ (data_user.phone)? data_user.phone:'-' }}</td>
  </tr>
  <tr>
    <th>อีเมล:</th>
    <td>{{ (data_user.email)? data_user.email:'-' }}</td>
  </tr>
  <tr>
    <th>ลงทะเบียน:</th>
    <td>{{ momentdatethai(data_user.create_at)}} {{ momenttimethai(data_user.create_at)}}น.</td>
  </tr>
</table>
<p style="margin-top: 30px;text-align: left;font-weight: bold;margin-bottom: 0px;">บทบาทผู้ใช้งาน</p>
<table class="customers">
  <tr>
    <th>ประเภทผู้ใช้งาน:</th>
    <td>{{ data_user.role}}</td>
  </tr>
  <tr>
    <th>บริษัท:</th>
    <td>{{ (data_user.company_name)? (data_user.company_name): '-'}}</td>
  </tr>
  <tr>
    <th>อาสาสมัคร:</th>
    <td>{{ volunteer(data_user.is_runner, data_user.is_cpr)}}</td>
  </tr>
</table>


     </div> 
   </div>
   </div>




<ChangeRole :dialogedit_role="dialogedit_role" :data_user="data_user" @closeedit_role="closeedit_role"></ChangeRole>



  </div>
</template>

<script>
import ChangeRole from '@/components/edit/edit_role_modal'
// var _ = require('lodash')
var moment = require('moment')
import { Decode, Momenttime } from '@/services'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      API_BACKEND: process.env.API_BACKEND,
      userid: '',
      data_user: {},
      authen: {},
      headerAPI: {},
      dialogedit_role: false
    }
  },
  created () {
    var decode = Decode.decode(localStorage.getItem('key'))
    this.authen = JSON.parse(decode)
    this.headerAPI = {Authorization: this.authen.Authorization}
    this.userid = this.$route.query.id
    this.getDetailUser()
  },
  components: {
    ChangeRole
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    routeinfo () {
      this.$router.back()
    },
    passwordCheck (password, is_generate) {
      if (is_generate) {
        return this.decodePassword(password)
      } else {
        return 'มีการเปลี่ยนแปลง'
      }
    },
    decodePassword (password) {
      return password
    },
    volunteer (runner, cpr) {
      if (cpr && runner) {
        return 'Hero CPR, Run for AED'
      } else if (cpr) {
        return 'Hero CPR'
      } else if (runner) {
        return 'Run for AED'
      } else {
        return '-'
      }
    },
    name (first,last) {
      if (first == null && last == null) {
        return '-'
      } else {
        return first + ' ' + last
      }

    },
    // checkTypeCompany (data) {
    //   if(data === 'owner') {
    //     return 'บริษัทในเครือสภากาชาด'
    //   } else if(data === 'partner') {
    //     return 'บริษัทร่วมโครงการ'
    //   } else if(data === 'maintenance') {
    //     return 'บริษัทบำรุงรักษาเครื่อง AED'
    //   } else {
    //     return '-'
    //   }

    // },
    momentdatethai(data) {
      return Momenttime.momentdatethai(data)
    },
    momenttimethai(data) {
      return Momenttime.momenttimethai(data)
    },
    print () {
      window.print()
    },
    changeRole () {
      this.dialogedit_role = true
    },
    closeedit_role () {
      this.dialogedit_role = false
    },
    getDetailUser () {
      var body = {
        userid: this.userid
      }
      this.axios.post(process.env.API_BACKEND + '/v1/getUserDetailByUserId', body, { headers: this.headerAPI }).then((response) => {
        this.data_user = response.data.data
      })
    }
  }
}
</script>
<style media="screen" scoped>
  >>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
  .inputinfor_address {
    height: 110px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor_dis {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: #FAF0F0 !important;
  }
  >>>.theme--dark.v-select .v-select__selections {
      color: #a80e00 !important;
  }
  >>>.theme--dark.v-label {
      color: hsl(5, 100%, 33%) !important;
  }
  >>>.theme--dark.v-icon {
      color: #a80e00 !important;
  }
  >>>.theme--dark.v-input:not(.v-input--is-disabled) input {
    color: #a80e00 !important;
  }
  .toolbarcreatedadmin {
    border-top-color: transparent !important;
    border-left-color: transparent !important;
    border-width: thin !important;
    border-right-color: transparent !important;
    border-style: solid !important;
    height: 64px !important;
    border-left-style: initial !important;
    border-right-style: initial !important;
    border-radius: 0px !important;
    border-bottom-color: #a80e00 !important;
    background-color: white !important;
    color: #a80e00 !important;
    border-width: thin !important;
    box-shadow: none !important;
  }
  .btngen {
    background-color: white !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
    width: 120px !important;
  }
  .btncreateuser {
    background-color: #a80f00 !important;
    color: #fafafa !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
  }
  .btncreateuser:disabled {
    background-color: #a80f0099 !important;
    color: #fafafa9c !important;
    border-color: #a80f0091 !important;
    border-style: solid !important;
    border-width: thin !important;
  }

  .btncancle {
    background-color: #fafafa !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    width: 160px !important;
  }

  .div_infor_header {
    width: 10vw;
    background: rgb(168, 14, 0) !important;
    color: white;
    text-align: right;
    padding-right: 20px;
  }
  .div_infor {
    width: 20vw;
    border: solid 1px #a80d00;
    text-align: left;
    padding-left: 20px;
  }
  .div_infor_headerDetail {
    width: 10vw;
    background: rgb(168, 14, 0) !important;
    color: white;
    text-align: right;
    padding-right: 10px;
  }
  .tableInfor {
    justify-content: center;
    display: inline-table;
    width: 70vw;
  }
  .positionPrint {
    width: 70vw;
      margin-left: 30vw;
      text-align: right;
      padding-right: 16vw;
  }

.customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
}

.customers td, .customers th {
  border: 1px solid #ddd;
  padding: 8px;
}


.customers th {
  background-color: #a80d00;
  color: white;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 10px;
  text-align: right !important;
  width: 35%;
}
.customers td {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  text-align: left !important;
  width: 400px;
}




  @media screen {
    #PDF {
     /* height: 60vh !important;
      overflow: scroll;*/
      display: none;
    }
  }
  @media print {
    .nonPrint {
      display: none;
    }
    #PDF {
      height: auto;
      overflow: hidden;
      -webkit-print-color-adjust: exact; 
    }
    .pageBreak { page-break-inside:always; }
    .pageBreak * {
      page-break-after:avoid;
      page-break-before:avoid;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/information_print/infor_user.vue